import React, { FC } from 'react';
import { Button, ButtonProps, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import { CarouselArrowIconPos } from 'svgs';

interface PrimaryButtonProps extends ButtonProps {
  text: string;
  onClick: () => void;
}

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.primary.dark,
    fontWeight: 400,
    minWidth: 366,
    maxHeight: 70,
    padding: theme.spacing(4),
    '& span': {
      '& div': {
        '& div': {
          '& svg': {
            '& path': {
              fill: theme.palette.primary.dark,
            },
          },
        },
      },
    },
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      '& span': {
        '& div': {
          '& div': {
            '& svg': {
              '& path': {
                fill: theme.palette.common.white,
              },
            },
          },
        },
      },
    },
  },
  text: {
    fontSize: 17,
  },
  icon: {
    marginBottom: theme.spacing(-0.5),
  },
}));

const BigButtonWithArrow: FC<PrimaryButtonProps> = ({ text, onClick }) => {
  const classes = useStyles();
  return (
    <Button variant={'contained'} className={classes.button} onClick={onClick}>
      <Grid container direction="row" justifyContent="space-between">
        <Grid item>
          <Typography className={classes.text}>{text}</Typography>
        </Grid>
        <Grid item>
          <CarouselArrowIconPos position="left" className={classes.icon} />
        </Grid>
      </Grid>
    </Button>
  );
};

export default BigButtonWithArrow;
